
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class TaskActionInquiryModel extends Model<TaskActionInquiryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'reply', type: 'string' }
	];
	[key: string]: any;
	
	public reply: string;
    
	constructor(){
		super();
		this.reply = '';
		
	}
	getProperties(){
		return TaskActionInquiryModel.classProperties;
	}
}

